import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M23.649 14.387 19.5 7.502V4.8c0-2.647-2.152-4.8-4.8-4.8H9.3a4.804 4.804 0 0 0-4.8 4.8v2.702L.344 14.399c-.228.388-.344.79-.344 1.197 0 1.323 1.076 2.4 2.4 2.4h19.199c1.324 0 2.4-1.077 2.4-2.4 0-.407-.114-.81-.35-1.21m-11.647 9.609c2.228 0 4.093-1.535 4.629-3.599H7.373c.535 2.063 2.4 3.599 4.629 3.599"
    }, null, -1)
  ])))
}
export default { render: render }